const preview = {
    namespaced: true,
    state: {
        categoryFields: {
            ACTIVITE: [],
            COMMERCE_ET_SERVICE: [],
            PRODUCTEUR: [],
            DOMAINE_SKIABLE_VTT: [],
            EQUIPEMENT: [],
            FETE_ET_MANIFESTATION: [],
            HEBERGEMENT_COLLECTIF: [],
            HEBERGEMENT_LOCATIF: [],
            HOTELLERIE: [],
            HOTELLERIE_PLEIN_AIR: [],
            PATRIMOINE_CULTUREL: [],
            PATRIMOINE_NATUREL: [],
            RESTAURATION: []
        },
        previewEditedTabulations: [],
        previewTxtIntro: null,
    },
    mutations: {
        setCategoryFields(state, [code, fields]) {
            state.categoryFields[code] = fields
        },
        setPreviewEditedTabulations(state, data) {
            state.previewEditedTabulations = data
        },
        setPreviewTxtIntro(state, value) {
            state.previewTxtIntro = value
        }
    }
}

export default preview